import classNames from 'classnames';
import { motion } from 'motion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import type { TabMenuProps } from './types';
import styles from './tab-menu.module.scss';
import { colors } from '@/Themes/Colors';

function TabMenu<T extends string = string>({
  tabsWithNotification,
  activatedTab,
  tabs,
  onChange,
  children,
  className,
  contentClassName,
  tags,
  id,
  variant = 'default',
}: TabMenuProps<T>) {
  return (
    <div className={className}>
      <div className={styles.tab} data-variant={variant}>
        {tabs.map(({ key, text, value }) => {
          const isActivated = activatedTab === value;

          const tag = tags?.[value];

          return (
            <button
              type="button"
              key={key}
              data-state={isActivated ? 'activated' : 'inactive'}
              onClick={() => onChange(value)}
              aria-selected={isActivated}
              role="tab"
            >
              <span>{text}</span>
              {tabsWithNotification?.includes(value) && (
                <FontAwesomeIcon
                  icon={faCircleExclamation}
                  color={colors.warning30}
                  size="xs"
                />
              )}
              {tag && (
                <div
                  className={styles.tag}
                  style={{
                    backgroundColor: tag.backgroundColor,
                    color: tag.color,
                  }}
                >
                  {tag.text}
                </div>
              )}
              {isActivated ? (
                <motion.div
                  className={styles.underline}
                  layoutId={`underline-${id}`}
                  id={`underline-${id}`}
                />
              ) : null}
            </button>
          );
        })}
      </div>

      {children && (
        <section className={classNames(styles.content, contentClassName)}>
          {children}
        </section>
      )}
    </div>
  );
}

export { TabMenu };
